import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Payload } from '@pezi/entities';

@Injectable()
export class PayloadUtil {
  // Fehlermessage Priorität: 1 - expliziter Parameter im Client, 2 - Message von DMW/CMW, sonst Defaultmeldung
  private static defaultErrorMsg = 'Es ist ein Fehler aufgetreten. Versuchen Sie es bitte später nochmal.';
  private static defaultSuccessMsg = 'Erfolgreich durchgeführt';

  public static getPayloadErrorMsg<T extends Payload>(payload: T): string {
    if (payload && payload.message && payload.message.length > 0) {
      return payload.message.map(v => v.text)
        .join(' / ');
    }
    return null;
  }

  public static handlePayloadSnackbar<T extends Payload>(
    payload: T,
    snackbar: MatSnackBar,
    successMsg: string = this.defaultSuccessMsg,
    failureMsg: string = this.defaultErrorMsg
  ): boolean {
    if (payload && payload.success && (payload as any).data) {
      if (payload.message && payload.message.length > 0 && successMsg === this.defaultSuccessMsg) {
        successMsg = payload.message.map(v => v.text)
          .join(' / ');
      }
      snackbar.open(successMsg ? successMsg : this.defaultSuccessMsg);
      return true;
    }
    if (failureMsg === this.defaultErrorMsg) {
      failureMsg = this.getPayloadErrorMsg(payload);
    }
    snackbar.open(failureMsg ? failureMsg : this.defaultErrorMsg);
    return false;
  }

  public static handlePayloadSnackbarErrorOnly<T extends Payload>(
    payload: T,
    snackbar: MatSnackBar,
    failureMsg: string = this.defaultErrorMsg
  ): boolean {
    if (payload && payload.success && (payload as any).data) {
      return true;
    }
    if (payload && payload.message && payload.message.length > 0 && failureMsg === this.defaultErrorMsg) {
      failureMsg = payload.message.map(v => v.text)
        .join(' / ');
    }
    snackbar.open(failureMsg ? failureMsg : this.defaultErrorMsg);
    return false;
  }

  public static checkPayload<T extends Payload>(payload: T): boolean {
    return !!(payload && payload.success && (payload as any).data);
  }
}
